// extracted by mini-css-extract-plugin
export default {"arrow_container":"CurrencyConverter_arrow_container__EDQ75","arrow":"CurrencyConverter_arrow__vO6pg"};